import { render, staticRenderFns } from "./HighlightsQRJourney.vue?vue&type=template&id=4beaf32b&scoped=true"
import script from "./HighlightsQRJourney.vue?vue&type=script&lang=js"
export * from "./HighlightsQRJourney.vue?vue&type=script&lang=js"
import style0 from "./HighlightsQRJourney.vue?vue&type=style&index=0&id=4beaf32b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beaf32b",
  null
  
)

export default component.exports